import e, { Component as t } from "react";
import n from "react-dom";
import o from "../../../../node_modules/classnames/index.js";
import r from "../../../utils/DomHandler.js";
import i from "../../../utils/ConnectedOverlayScrollHandler.js";
function a(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function s(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function l(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function u(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function c(e) {
  return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function p(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {},
      o = Object.keys(n);
    "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
      return Object.getOwnPropertyDescriptor(n, e).enumerable;
    }))), o.forEach(function (t) {
      u(e, t, n[t]);
    });
  }
  return e;
}
function d(e, t) {
  return (d = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var f = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && d(e, t);
  }(y, t);
  var f,
    h,
    v,
    m = (f = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        n = c(y);
      if (f) {
        var o = c(this).constructor;
        t = Reflect.construct(n, arguments, o);
      } else t = n.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : s(this);
    });
  function y(e) {
    var t;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, y), u(s(t = m.call(this, e)), "tooltipTextEl", void 0), u(s(t), "containerEl", void 0), u(s(t), "currentTarget", void 0), u(s(t), "scrollHandler", void 0), u(s(t), "documentResizeListener", void 0), u(s(t), "allowHide", void 0), u(s(t), "showDelayTimeout", void 0), u(s(t), "hideDelayTimeout", void 0), u(s(t), "updateDelayTimeout", void 0), u(s(t), "appendTo", t.props.appendTo || document.body), u(s(t), "show", function (e) {
      t.currentTarget = e.currentTarget;
      var n = function n() {
        t.updateText(t.currentTarget, function () {
          t.props.autoZIndex && !t.containerEl.style.zIndex && (t.containerEl.style.zIndex = String(t.props.baseZIndex + r.generateZIndex())), t.containerEl.style.left = "", t.containerEl.style.top = "", t.align(t.currentTarget, {
            x: e.pageX,
            y: e.pageY
          });
        });
      };
      t.state.visible ? t.applyDelay("updateDelay", n) : (t.sendCallback(t.props.onBeforeShow, {
        originalEvent: e,
        target: t.currentTarget
      }), t.applyDelay("showDelay", function () {
        t.setState({
          visible: !0
        }, function () {
          n(), t.sendCallback(t.props.onShow, {
            originalEvent: e,
            target: t.currentTarget
          });
        }), t.bindDocumentResizeListener(), t.bindScrollListener();
      }));
    }), u(s(t), "hide", function (e) {
      t.clearTimeouts(), t.state.visible && (t.sendCallback(t.props.onBeforeHide, {
        originalEvent: e,
        target: t.currentTarget
      }), t.applyDelay("hideDelay", function () {
        r.removeClass(t.containerEl, "kaseya-ui-tooltip--active"), !1 !== t.allowHide && t.setState({
          visible: !1,
          position: t.props.position
        }, function () {
          t.tooltipTextEl && n.unmountComponentAtNode(t.tooltipTextEl), t.unbindDocumentResizeListener(), t.unbindScrollListener(), t.currentTarget = null, t.scrollHandler = null, t.allowHide = !0, t.sendCallback(t.props.onHide, {
            originalEvent: e,
            target: t.currentTarget
          });
        });
      }));
    }), u(s(t), "align", function (e, n) {
      var o = 0,
        i = 0;
      if (t.props.mouseTrack && n) {
        var a = {
          width: r.getOuterWidth(t.containerEl),
          height: r.getOuterHeight(t.containerEl)
        };
        switch (o = n.x, i = n.y, t.state.position) {
          case "left":
            o -= a.width + t.props.mouseTrackLeft, i -= a.height / 2 - t.props.mouseTrackTop;
            break;
          case "right":
            o += t.props.mouseTrackLeft, i -= a.height / 2 - t.props.mouseTrackTop;
            break;
          case "top":
            o -= a.width / 2 - t.props.mouseTrackLeft, i -= a.height + t.props.mouseTrackTop;
            break;
          case "bottom":
            o -= a.width / 2 - t.props.mouseTrackLeft, i += t.props.mouseTrackTop;
        }
        t.containerEl.style.left = o + "px", t.containerEl.style.top = i + "px", r.addClass(t.containerEl, "kaseya-ui-tooltip--active");
      } else {
        var s = r.findCollisionPosition(t.state.position),
          l = t.props.my || s.my,
          u = t.props.at || s.at;
        r.flipfitCollision(t.containerEl, e, l, u, function (e) {
          var n = e.at,
            o = n.x,
            i = n.y,
            a = t.props.at ? "center" !== o ? o : i : e.at["".concat(s.axis)];
          t.setState({
            position: a
          }, function () {
            return r.addClass(t.containerEl, "kaseya-ui-tooltip--active");
          });
        });
      }
    }), u(s(t), "onMouseEnter", function () {
      t.allowHide = !1;
    }), u(s(t), "onMouseLeave", function (e) {
      var n = e.currentTarget.getBoundingClientRect(),
        o = n.top,
        r = n.right,
        i = n.bottom,
        a = n.left;
      e.clientX > a && e.clientX < r && e.clientY > o && e.clientY < i || (t.allowHide = !0, t.hide(e));
    }), t.state = {
      visible: !1,
      position: t.props.position
    }, t;
  }
  return h = [{
    key: "getEvents",
    value: function value() {
      var e = this.props,
        t = e.showEvent,
        n = e.hideEvent;
      return this.props.mouseTrack ? (t = "mousemove", n = "mouseleave") : "focus" === this.props.event && (t = "focus", n = "blur"), {
        showEvent: t,
        hideEvent: n
      };
    }
  }, {
    key: "updateText",
    value: function value(t, o) {
      if (this.tooltipTextEl) {
        var r = this.props.content;
        t && t.hasAttribute("data-kaseya-ui-tooltip") && (r = t.getAttribute("data-kaseya-ui-tooltip")), r ? e.isValidElement(r) ? n.render(r, this.tooltipTextEl, o) : (r = e.createElement("div", {
          className: "kaseya-ui-tooltip__text"
        }, r), n.render(r, this.tooltipTextEl, o), o()) : this.props.child && (n.unmountComponentAtNode(this.tooltipTextEl), n.render(e.createElement(e.Fragment, null, this.props.child), this.tooltipTextEl, o));
      }
    }
  }, {
    key: "bindDocumentResizeListener",
    value: function value() {
      var e = this;
      this.documentResizeListener = function (t) {
        e.hide(t);
      }, window.addEventListener("resize", this.documentResizeListener);
    }
  }, {
    key: "unbindDocumentResizeListener",
    value: function value() {
      this.documentResizeListener && (window.removeEventListener("resize", this.documentResizeListener), this.documentResizeListener = null);
    }
  }, {
    key: "bindScrollListener",
    value: function value() {
      var e = this;
      this.scrollHandler || (this.scrollHandler = new i(this.currentTarget, function () {
        e.state.visible && e.hide(null);
      })), this.scrollHandler.bindScrollListener();
    }
  }, {
    key: "unbindScrollListener",
    value: function value() {
      this.scrollHandler && this.scrollHandler.unbindScrollListener();
    }
  }, {
    key: "bindTargetEvent",
    value: function value(e) {
      if (e) {
        var t = this.getEvents(),
          n = t.showEvent,
          o = t.hideEvent;
        e.addEventListener(n, this.show), e.addEventListener(o, this.hide);
      }
    }
  }, {
    key: "unbindTargetEvent",
    value: function value(e) {
      if (e) {
        var t = this.getEvents(),
          n = t.showEvent,
          o = t.hideEvent;
        e.removeEventListener(n, this.show), e.removeEventListener(o, this.hide);
      }
    }
  }, {
    key: "applyDelay",
    value: function value(e, t) {
      this.clearTimeouts();
      var n,
        o = null === (n = this.props.options) || void 0 === n ? void 0 : n[e];
      o ? this["".concat(e, "Timeout")] = window.setTimeout(function () {
        return t();
      }, o) : t();
    }
  }, {
    key: "sendCallback",
    value: function value(e) {
      for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) n[o - 1] = arguments[o];
      e && e.apply(void 0, function (e) {
        if (Array.isArray(e)) return a(e);
      }(n) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(n) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return a(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          if ("Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n) return Array.from(n);
          if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return a(e, t);
        }
      }(n) || function () {
        throw TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }());
    }
  }, {
    key: "clearTimeouts",
    value: function value() {
      clearTimeout(this.showDelayTimeout), clearTimeout(this.updateDelayTimeout), clearTimeout(this.hideDelayTimeout);
    }
  }, {
    key: "loadTargetEvents",
    value: function value() {
      var e = this;
      if (r.isElement(this.props.target)) this.bindTargetEvent(this.props.target);else {
        var t = function t(_t) {
          r.find(document, _t).forEach(function (t) {
            e.bindTargetEvent(t);
          });
        };
        this.props.target instanceof Array ? this.props.target.forEach(function (e) {
          t(e);
        }) : t(this.props.target);
      }
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.props.target && this.loadTargetEvents();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      var t = this;
      e.target !== this.props.target && this.loadTargetEvents(), this.state.visible && e.content !== this.props.content && this.applyDelay("updateDelay", function () {
        t.updateText(t.currentTarget, function () {
          t.align(t.currentTarget, {});
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.clearTimeouts(), this.unbindDocumentResizeListener(), this.scrollHandler && (this.scrollHandler.destroy(), this.scrollHandler = null);
    }
  }, {
    key: "renderElement",
    value: function value() {
      var t,
        n = this,
        r = o("kaseya-ui-tooltip", u({}, "kaseya-ui-tooltip__".concat(this.state.position), !0), this.props.className);
      return e.createElement("div", p({
        ref: function ref(e) {
          return n.containerEl = e;
        },
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        className: r,
        style: this.props.style,
        role: "tooltip"
      }, null === (t = this.props.options) || void 0 === t ? void 0 : t.containerAttributes), e.createElement("div", {
        ref: function ref(e) {
          return n.tooltipTextEl = e;
        }
      }));
    }
  }, {
    key: "render",
    value: function value() {
      if (this.state.visible) {
        var e = this.renderElement();
        return n.createPortal(e, this.appendTo);
      }
      return null;
    }
  }], l(y.prototype, h), v && l(y, v), y;
}(t);
function h(t) {
  var o = t.appendTo || document.body,
    i = document.createDocumentFragment();
  r.appendChild(i, o), t = p({}, t, t.options);
  var a = e.createElement(f, t);
  return n.render(a, i), {
    destroy: function destroy() {
      n.unmountComponentAtNode(i);
    },
    updateContent: function updateContent(t) {
      n.render(e.cloneElement(a, {
        content: t
      }), i);
    }
  };
}
u(f, "displayName", "Tooltip"), u(f, "defaultProps", {
  position: "right",
  showEvent: "mouseenter",
  hideEvent: "mouseleave",
  autoZIndex: !0,
  baseZIndex: 0,
  mouseTrack: !1,
  mouseTrackTop: 5,
  mouseTrackLeft: 5
});
export { f as Tooltip, h as tip };